import { useFormik } from "formik";
import React from "react";

import { Button, Card, Form } from "react-bootstrap";
import { setDesig_LevelMessage } from "redux/actions";


import { useAppDispatch } from "redux/store";
import { addDesig_Level, updateDesig_Level } from "services/desig_levelService";
import { Constant } from "template/Constant";
import * as yup from 'yup';
type Props = {
    row?: any,
    hideShowForm: (actionName) => void;
    getData: (page, pageSize, searchKey) => void;
    action?: string
};
export const Desig_LevelForm: React.FC<Props> = ({ row, hideShowForm, getData, action }) => {
    const dispatch = useAppDispatch();
    const iValue={desig_level_id:0,desig_level_name:'',is_active:''};
    const initialValue = action === 'edit' ? row : iValue;
    
    
    const formik = useFormik({
        initialValues: initialValue,
        onSubmit: async (values) => {
            if (action === 'edit') {
                const response = await updateDesig_Level(row.desig_level_id,values);
               if (response && (response.status === 200 || response.status === 201)) {
                    dispatch(setDesig_LevelMessage("Updated Successfully"));
                    getData(Constant.defaultPageNumber, Constant.defaultPageSize, '');
                    hideShowForm('');
                } else {
                    dispatch(setDesig_LevelMessage("Some error occured!"));
                }
            } else if (action === 'add') {
                const response = await addDesig_Level(values);
               if (response && (response.status === 200 || response.status === 201)) {
                    dispatch(setDesig_LevelMessage("Added Successfully"));
                    getData(Constant.defaultPageNumber, Constant.defaultPageSize, '');
                    hideShowForm('');
                } else {
                    dispatch(setDesig_LevelMessage("Some error occured!"));
                }
            }
        },
        validationSchema: yup.object({
           desig_level_name: yup.string().required('desig_level_name is required'),
is_active: yup.boolean().required('is_active is required'),

        }),
    });
    return (
        <Card className="shadow mb-4">
            <Card.Header className="py-3">
                <h6 className="m-0 font-weight-bold text-primary text-capitalize">{action} Desig_Level
                    <Button className="btn-icon-split float-right" onClick={() => hideShowForm(false)}>
                        <span className="icon text-white-50">
                            <i className="fas fa-list"></i>
                        </span>
                        <span className="text">View Desig_Level</span>
                    </Button>
                </h6>

            </Card.Header>
            <Card.Body>
                <Form onSubmit={formik.handleSubmit}>
                  <Form.Group>
<label className="form -control-label">desig_level_name</label>
<Form.Control type="text" name="desig_level_name" className="form-control" value={formik.values.desig_level_name}
onChange={formik.handleChange}
onBlur ={formik.handleBlur}
isInvalid ={!!formik.touched.desig_level_name && !!formik.errors.desig_level_name}
isValid ={!!formik.touched.desig_level_name && !formik.errors.desig_level_name}
></Form.Control>
{
    formik.errors.desig_level_name && (
    <Form.Control.Feedback type="invalid">
        <>{formik.errors.desig_level_name}</>
    </Form.Control.Feedback>
)}
</Form.Group>
<Form.Group>
<label className="form -control-label">is_active</label>
<Form.Control type="number" name="is_active" className="form-control" value={formik.values.is_active}
onChange={formik.handleChange}
onBlur ={formik.handleBlur}
isInvalid ={!!formik.touched.is_active && !!formik.errors.is_active}
isValid ={!!formik.touched.is_active && !formik.errors.is_active}
></Form.Control>
{
    formik.errors.is_active && (
    <Form.Control.Feedback type="invalid">
        <>{formik.errors.is_active}</>
    </Form.Control.Feedback>
)}
</Form.Group>

                    <Form.Group>
                        <Button type="submit" className="float-right" variant="primary">Save</Button>
                    </Form.Group>
                </Form>
            </Card.Body>
        </Card>
    );
}

